import ajax from 'utils/request';

export function changePassword(params) {
    return ajax('PUT', '/user/update-password', params);
}



// WEBPACK FOOTER //
// ./src/actions/user.js